module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_3.adae5040.png";